import { Markdown } from '@cadstrom/sigma-engine-shared';

import { BasicRemarkPlugin } from './markdown-plugins-utils.js';
import { ModelRenderMarkdownItem } from './model-render-markdown-item.js';

import type { RemarkMarkdownDirectiveDefinition } from './markdown-plugins-utils.js';

/**
 * Directive name for inline project-model render embeds:
 * `::model-render[Gateway board]{attachmentId="asrtatch_…"}` for a saved block
 * diagram, or `::model-render[Power sheet]{designId="…" bbox="0,0,400,300"}`
 * for a design of the current revision's project model.
 */
export const MODEL_RENDER_DIRECTIVE = 'model-render';

/**
 * Remark plugin definition for the `model-render` directive. The directive
 * content is the display label; attributes select the source and view — see
 * {@link ModelRenderMarkdownItem}.
 */
export const modelRenderDirectiveDefinition: RemarkMarkdownDirectiveDefinition = {
	allowedAttributes: ['label', 'attachmentId', 'designId', 'bbox'],
	directive: BasicRemarkPlugin(MODEL_RENDER_DIRECTIVE, Markdown.NodeTypes.AllDirectives, {
		contentPropName: 'label',
	}),
	item: ModelRenderMarkdownItem,
};
